<template>
<form @submit.prevent="emitSave" id="AffinityTableAddEditDialog">
  <h4 class="mb-4">{{ 'ADD' | translate }}</h4>

  <div class="form-group" id="AffinityTableAddEditDialog-formGroup-Collectiviteitscode">
    <label>{{ 'Collectiviteitscode' | translate }} <span class="asterisk">*</span></label>
    <input type="text"
           class="form-control form-control-sm"
           v-model="affinity.code"
           required
           id="AffinityTableAddEditDialog-formGroup-Collectiviteitscode-input">
  </div>

  <div class="form-group" id="AffinityTableAddEditDialog-formGroup-Collectiviteitnaam">
    <label>{{ 'Collectiviteitnaam' | translate }}</label>
    <input type="text"
           class="form-control form-control-sm"
           v-model="affinity.name"
           id="AffinityTableAddEditDialog-formGroup-Collectiviteitnaam-input">
  </div>

  <div class="form-group" id="AffinityTableAddEditDialog-formGroup-Dekking">
    <label>{{ 'Dekking' | translate }}</label>
    <select class="form-control form-control-sm"
            v-model="affinity.coverType"
            id="AffinityTableAddEditDialog-formGroup-Dekking-select">
      <option value="" :id="'AffinityTableAddEditDialog-select-option-Dekking-'+ ' '"></option>
      <template v-for="cover in covers">
        <option :key="cover" :value="cover" :id="'AffinityTableAddEditDialog-select-option-'+cover">{{ cover | translate('cover') }}</option>
      </template>
    </select>
  </div>

  <div class="form-group" id="AffinityTableAddEditDialog-formGroup-Maatschappij">
    <label>{{ 'Maatschappij' | translate }}</label>
    <select class="form-control form-control-sm"
            v-model="affinity.insurerName"
            id="AffinityTableAddEditDialog-formGroup-Maatschappij-select">
      <option value="" :id="'AffinityTableAddEditDialog-select-option-Maatschappij-'+ ' '"></option>
      <template v-for="insurer in insurers">
        <option :key="insurer.name" :value="insurer.name" :id="'AffinityTableAddEditDialog-select-option-'+insurer.name">{{ insurer.name | translate('insurer') }}</option>
      </template>
    </select>
  </div>

  <div class="form-group" id="AffinityTableAddEditDialog-formGroup-Collectiviteitskorting">
    <label>{{ 'Collectiviteitskorting (%)' | translate }} <span class="asterisk">*</span></label>
    <input type="number"
           min="0"
           step=".01"
           class="form-control form-control-sm"
           v-model="affinity.percentage"
           required
           id="AffinityTableAddEditDialog-formGroup-Collectiviteitskorting-input">
  </div>

  <div class="form-group" id="AffinityTableAddEditDialog-formGroup-Startdatum">
    <label>{{ 'Startdatum' | translate }}</label>
    <datepicker v-model="affinity.startDate"
                format="dd-MM-yyyy"
                language="nl"
                input-class="form-control form-control-sm bg-white"
                id="AffinityTableAddEditDialog-dataePicker-Startdatum">
    ></datepicker>
  </div>

  <div class="mt-4 text-right" id="AffinityTableAddEditDialog-formGroup-buttons">

    <button class="btn btn-link"
            type="button"
            @click="emitClose"
            id="AffinityTableAddEditDialog-closeButton"
    >{{ 'CLOSE' | translate }}</button>

    <button class="btn btn-primary"
            type="submit"
            :disabled="!isFormValid"
            id="AffinityTableAddEditDialog-addButton"
    >{{ 'ADD' | translate }}</button>

  </div>
</form>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
export default {
  props: [ 'edited', 'covers', 'insurers' ],
  components: { Datepicker },
  data() {
    return {
      affinity: {}
    }
  },
  computed: {
    isFormValid() {
      return this.affinity.code &&
             this.affinity.percentage;
    }
  },
  methods: {
    emitSave() {
      this.$emit(this.edited ? 'update' : 'save', this.affinity);
      this.affinity = {};
    },
    emitClose() {
      this.$emit('close');
      this.affinity = {};
    }
  },
  watch: {
    edited(newVal, oldVal) {
      this.affinity = { ...newVal };
    }
  }
}
</script>

<style lang="scss" scoped>
.asterisk {
  color: $danger;
}

>>> .vdp-datepicker__calendar {
  bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/affinity/AffinityAddEditDialog.vue